/**
 * @generated SignedSource<<518d30f0c00247b4a333c68e3244b624>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UnmarkProgramAsFavoriteInput = {
  programId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type unmarkProgramAsFavoriteMutation$variables = {
  input: UnmarkProgramAsFavoriteInput;
};
export type unmarkProgramAsFavoriteMutation$data = {
  readonly unmarkProgramAsFavorite: {
    readonly unmarkedProgramId: string | null;
    readonly program: {
      readonly node: {
        readonly id: string;
        readonly userRelationTypes: ReadonlyArray<string | null> | null;
      } | null;
    } | null;
  } | null;
};
export type unmarkProgramAsFavoriteMutation = {
  variables: unmarkProgramAsFavoriteMutation$variables;
  response: unmarkProgramAsFavoriteMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UnmarkProgramAsFavoritePayload",
    "kind": "LinkedField",
    "name": "unmarkProgramAsFavorite",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unmarkedProgramId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectServiceProgramTypeEdge",
        "kind": "LinkedField",
        "name": "program",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProgramType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userRelationTypes",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "unmarkProgramAsFavoriteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "unmarkProgramAsFavoriteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2c99296ff5155199019da1730ae06b9c",
    "id": null,
    "metadata": {},
    "name": "unmarkProgramAsFavoriteMutation",
    "operationKind": "mutation",
    "text": "mutation unmarkProgramAsFavoriteMutation(\n  $input: UnmarkProgramAsFavoriteInput!\n) {\n  unmarkProgramAsFavorite(input: $input) {\n    unmarkedProgramId\n    program {\n      node {\n        id\n        userRelationTypes\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "de9a4aaec116b8a7b066479f46792c72";

export default node;
